<template>
  <a
    class="bg-white flex flex-row transition-opacity duration-300 ease-in-out md:hover:opacity-80"
    :href="article.link"
  >
    <div class="block w-16 h-16 sm:w-24 sm:h-24 my-4 p-2">
      <SanityImage
        v-if="article.image"
        class="bg-gray-100 h-full"
        image-class="rounded-8 sm:rounded-12"
        :image="article.image"
        no-copyright
      />
      <div v-else class="bg-brand-100 w-full h-full content-center rounded-8 sm:rounded-12">
        <svg role="presentation" focusable="false" tabindex="-1"   alt="" svg-inline  fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 1066">
  <path stroke="#fff" stroke-width="30" d="M508 308h584v450H508z"/>
  <circle cx="872.5" cy="426.5" r="46.5" fill="#fff"/>
  <path d="M585 586.5 706.2 436 821 586.5l95.2-84.5 98.8 84.5V716H585V586.5Z" fill="#fff"/>
</svg>
      </div>
    </div>
    <div class="no-underline flex flex-1 flex-col p-4 lg:p-5">
      <div class="text-16 sm:text-14 mb-2 font-bold text-gray-800 leading-5">
        {{ article.title }}
      </div>
      <div class="text-13 font-semibold text-gray-400 tracking-wide">
        <NuxtTime
          v-if="article.lastUpdated"
          :datetime="article.lastUpdated"
          :locale="$lang"
          date-style="long"
        /><template v-if="article.authorName && article.lastUpdated"> - </template
        ><template v-if="article.authorName">{{ $t('by') }} {{ article.authorName }}</template>
      </div>
    </div>
  </a>
</template>

<script lang="ts" setup>
import type { GQLRelatedContentSlice } from './generated/related-content'

defineProps<{ article: GQLRelatedContentSlice['articleLinks'][number] }>()
</script>
